import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';

export type StarSpace = {
  spaceId: string;
  showArchived: boolean;
  sort: string;
  search: string;
  category: string;
  subCategory: string;
};

export const OverlayContainer = ({ palette, isAssigned }: any) =>
  !isAssigned ? (
    <Box
      className="overlay"
      onClick={(e) => e.stopPropagation()}
      sx={{
        position: 'absolute',
        backgroundColor:
          palette.mode === 'dark'
            ? 'rgba(0, 0, 0, 0.85)'
            : 'rgba(255, 255, 255, 0.95)',
        color: palette.mode === 'dark' ? '#fff' : '#000',
        width: '100%',
        height: '100%',
        top: 0,
        borderRadius: '0.5rem',
        padding: '1.6rem',
        opacity: 0.95,
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '0.875rem',
        fontWeight: '500',
        textAlign: 'center',
        cursor: 'not-allowed',
        boxShadow:
          palette.mode === 'dark'
            ? '0 4px 8px rgba(0, 0, 0, 0.3)'
            : '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
      tabIndex={0}
    >
      You no longer have access to this space.
    </Box>
  ) : null;
